import apiClient from './apiClient';

// Subscription service — mirrors r2b-restaurant-mobile-new/src/services/subscriptionService.js.
// Endpoints and payload shapes are preserved verbatim.

export const subscriptionService = {
  getSubscriptionStatus: async (branchId) => {
    const response = await apiClient.get(`/subscription-status?branchId=${branchId}`);
    return response.data;
  },

  getAllSubscriptions: async () => {
    const response = await apiClient.get('/subscriptions');
    return response.data;
  },

  purchaseSubscription: async (branchId, subscriptionId, amount, tierData) => {
    const response = await apiClient.post('/subscription/purchase', {
      branchId,
      subscriptionId,
      amount,
      tierId: tierData?.tierId,
      maxOrders: tierData?.maxOrders || 1000,
      minOrders: tierData?.minOrders || 0,
      durationInDays: tierData?.durationInDays || 30,
    });
    return response.data;
  },

  verifyPurchaseSubscription: async (paymentData, branchId, subscriptionId, amount, restaurantData) => {
    const verificationData = {
      razorpay_payment_id: paymentData.razorpayPaymentId,
      razorpay_order_id: paymentData.razorpayOrderId,
      razorpay_signature: paymentData.razorpaySignature,
      branchId,
      subscriptionId,
      amount,
      restaurantData,
    };
    const response = await apiClient.post('/subscription/purchase-verify', verificationData);
    return response.data;
  },

  calculateUpgradeCost: async (branchId, newSubscriptionId, tierId) => {
    const response = await apiClient.post('/subscription/calculate-upgrade-cost', {
      branchId,
      newSubscriptionId,
      tierId,
    });
    return response.data;
  },

  upgradeSubscription: async (branchId, newSubscriptionId, amount, tierData) => {
    const response = await apiClient.post('/subscription/upgrade', {
      branchId,
      newSubscriptionId,
      amount,
      tierId: tierData?.tierId,
      maxOrders: tierData?.maxOrders || 1000,
      minOrders: tierData?.minOrders || 0,
      durationInDays: tierData?.durationInDays || 30,
    });
    return response.data;
  },

  verifyUpgradeSubscription: async (paymentData, branchId, newSubscriptionId, amount, restaurantData) => {
    const verificationData = {
      razorpay_payment_id: paymentData.razorpayPaymentId,
      razorpay_order_id: paymentData.razorpayOrderId,
      razorpay_signature: paymentData.razorpaySignature,
      branchId,
      newSubscriptionId,
      amount,
      restaurantData,
    };
    const response = await apiClient.post('/subscription/upgrade-verify', verificationData);
    return response.data;
  },

  renewSubscription: async (branchId, amount, tierData) => {
    const response = await apiClient.post('/subscription/renew', {
      branchId,
      amount,
      tierId: tierData?.tierId,
      maxOrders: tierData?.maxOrders || 1000,
      minOrders: tierData?.minOrders || 0,
      durationInDays: tierData?.durationInDays || 30,
    });
    return response.data;
  },

  verifyRenewSubscription: async (paymentData, branchId, subscriptionId, amount, restaurantData) => {
    const verificationData = {
      razorpay_payment_id: paymentData.razorpayPaymentId,
      razorpay_order_id: paymentData.razorpayOrderId,
      razorpay_signature: paymentData.razorpaySignature,
      branchId,
      subscriptionId,
      amount,
      restaurantData,
    };
    const response = await apiClient.post('/subscription/renew-verify', verificationData);
    return response.data;
  },

  topUpOrderCount: async (branchId, additionalOrders) => {
    const response = await apiClient.post('/subscription-topup', {
      branchId,
      additionalOrders,
    });
    return response.data;
  },

  verifyTopUpPayment: async (paymentData, branchId, amount, restaurantData) => {
    const verificationData = {
      razorpay_payment_id: paymentData.razorpayPaymentId,
      razorpay_order_id: paymentData.razorpayOrderId,
      razorpay_signature: paymentData.razorpaySignature,
      branchId,
      amount,
      restaurantData,
    };
    const response = await apiClient.post('/subscription-topup-verify', verificationData);
    return response.data;
  },

  calculateRenewalCost: async (branchId, tierId) => {
    const response = await apiClient.post('/subscription/calculate-renewal-cost', {
      branchId,
      tierId,
    });
    return response.data;
  },
};

export default subscriptionService;
